/**
 * Backend base URL for browser and server.
 * Server-side fetch often fails with `localhost` on Windows (IPv6 vs IPv4); 127.0.0.1 is reliable.
 */
export function getApiBase(): string {
  const fromEnv = process.env.NEXT_PUBLIC_API_BASE_URL?.trim()
  const raw = fromEnv
    ? fromEnv
    : typeof window === "undefined"
      ? "http://127.0.0.1:8300"
      : window.location.origin
  return raw.replace(/\/+$/, "")
}
